import classNames from "classnames/bind";
import { DemographicAnswerOption } from "../../../../gql/graphql";
import { DemographicResponse } from "../types";
import styles from "../../QuizGame.module.scss";

const cx = classNames.bind(styles);

interface DemographicMultiSelectInputProps {
  options: DemographicAnswerOption[];
  selectedOptionIds: string[];
  onChange: (response: Partial<DemographicResponse>) => void;
}

export const DemographicMultiSelectInput = ({
  options,
  selectedOptionIds,
  onChange,
}: DemographicMultiSelectInputProps) => {
  const handleOptionClick = (optionId: string) => {
    const currentSelected = selectedOptionIds || [];
    let newSelected: string[];

    if (currentSelected.includes(optionId)) {
      newSelected = currentSelected.filter((id) => id !== optionId);
    } else {
      newSelected = [...currentSelected, optionId];
    }

    onChange({ selectedOptionIds: newSelected });
  };

  return (
    <div className={styles.answersWrapper}>
      {options.map((option) => (
        <button
          key={option.id}
          type="button"
          className={cx("answerOption", {
            selected: selectedOptionIds.includes(option.id),
          })}
          onClick={() => handleOptionClick(option.id)}
          style={{
            backgroundColor: selectedOptionIds.includes(option.id) ? "#faa61a" : "white",
            color: selectedOptionIds.includes(option.id) ? "white" : "black",
          }}
        >
          <span>{option.text}</span>
        </button>
      ))}
    </div>
  );
};
